const INTENT_KEY = "srd_pending_website_setup";
const INTENT_TTL = 30 * 60 * 1000;

export function normalizeWebsite(value) {
  const input = value.trim();
  if (!input || input.length > 2048 || /\s/.test(input)) {
    throw new Error("Enter a valid website address, such as yourcompany.com.");
  }
  let url;
  try { url = new URL(input.includes("://") ? input : `https://${input}`); }
  catch { throw new Error("Enter a valid website address, such as yourcompany.com."); }
  const hostname = url.hostname;
  const validDomain = hostname.split(".").every((part) => /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(part));
  if (!["http:", "https:"].includes(url.protocol) || url.username || url.password ||
      !hostname.includes(".") || !validDomain || /^\d+(\.\d+){3}$/.test(hostname) ||
      /\.(localhost|local|internal)$/i.test(hostname)) {
    throw new Error("Enter a public website address using http or https.");
  }
  url.hash = "";
  return url.href;
}

export function saveWebsiteSetupIntent(website) {
  try {
    sessionStorage.setItem(INTENT_KEY, JSON.stringify({ website: normalizeWebsite(website), expiresAt: Date.now() + INTENT_TTL }));
  } catch {
    throw new Error("Your browser could not save this website. Please allow site storage and try again.");
  }
}

export function clearWebsiteSetupIntent() {
  try { sessionStorage.removeItem(INTENT_KEY); } catch { /* Storage may be unavailable. */ }
}

function pendingWebsite() {
  try {
    const intent = JSON.parse(sessionStorage.getItem(INTENT_KEY));
    if (!intent || !Number.isFinite(intent.expiresAt) || intent.expiresAt <= Date.now()) return "";
    return normalizeWebsite(intent.website);
  } catch { return ""; }
}

export function websiteSetupDestination(user) {
  if (!user) return "/login";
  const website = pendingWebsite();
  const destination = user.onboarding_completed ? (website ? "/app/analytics" : "/app") : "/onboarding";
  return website ? `${destination}?website=${encodeURIComponent(website)}` : destination;
}

export function websiteFromSearch(search) {
  const website = new URLSearchParams(search).get("website");
  if (!website) return "";
  try { return normalizeWebsite(website); } catch { return ""; }
}